import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { BuilderSections } from '../../util/builder';
import { getGenderFilterConfig } from '../filters/gender';

const cafeducyclisteDeSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'One Size'];

export const cafeducyclisteDeShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: cafeducyclisteDeSizes,
    }),
    getBrandDirectFilterConfig(),
    getGenderFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.FooterContent]: '92549b15f66846c69bc4f6da98fbf700',
    },
  },
};
